module.exports = __webpack_public_path__ + "img/emoji-stalker-240x240.c460614d.png";